import { cookie } from './cookie.js';
import { openDesktopLocationSelect, closeDesktopLocationSelect } from './menus.js';

var settingElsewhere = false;

function initCommunity() {
	var ocb = cookie('ocb') || {};

	function setCommunity(id) {
		// $.ajax('/wp-json/onecommunitybank/v1/home/', {
		// 	method: 'POST',
		// 	data: {
		// 		id: id
		// 	},
		// 	xhrFields: { withCredentials: true }
		// });

		var ocb = cookie('ocb') || {};

		ocb['home'] = id;

		cookie('ocb', ocb, 60*60*24*365);
	}

	if (ocb && ocb.home) {
		$('[data-js="my-location-select"]').val(ocb.home);
		$('[data-js="set-my-location"][data-id="' + ocb.home + '"]').prop('checked', true);
		$('[data-community-id="' + ocb.home + '"]').addClass('home-community');
	}

	// function getCommunity() {
	// 	$.ajax('/wp-json/onecommunitybank/v1/home/', {
	// 		method: 'GET',
	// 		xhrFields: { withCredentials: true },
	// 		success: function (data) {
	// 			console.log('home:', data);
	// 		}
	// 	});
	// }

	$('body').on('change', '[data-js="set-my-location"]', function (event, noSet) {
		var checkbox = $(this);

		if (settingElsewhere) {
			return;
		}

		if (!noSet) {
			if (checkbox.is(':checked')) {
				setCommunity(checkbox.data('id'));

				//uncheck other checkboxes
				$('[data-js="set-my-location"]:not([data-id="' + checkbox.data('id') + '"]').prop('checked', false);

				//update location select in header
				$('[data-js="location-choice"][data-id="' + checkbox.data('id') + '"]').trigger('click', [true]);
			} else {
				setCommunity(false);
			}
		}
	});

	$('body').on('change', '[data-js="my-location-select"]', function (e) {
		//let other key presses proceed as normal (namely 'tab' keyboard navigation)
		console.log($(this).val());

		setCommunity($(this).val());

		return false;
	});
}

export { initCommunity };
